import axios from "axios";
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

export const sendMailService = async (token,type) => {
      console.log(type)
    try {
        const response = await heyapi.post(
            `/admin/mail/${type}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};